<template>
  <th class="text-style-xs font-medium text-tertiary">
    <div class="flex flex-col">
      <div
        :class="{ 'cursor-pointer': isSortable }"
        class="flex flex-row gap-1 items-center px-2 h-[36px]"
        @click="handleSort"
      >
        {{ label }}
        <Icon
          v-if="sortBy === field && isSortable"
          :name="orderBy === 'asc' ? 'chevron-up' : 'chevron-down'"
          size="xs"
        />
      </div>
    </div>
  </th>
</template>

<script setup>
// Import Components
import { Icon } from "@/SharedComponents/Icon";

// Define Props
const props = defineProps({
  field: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  isSortable: {
    type: Boolean,
    default: false,
  },
  sortBy: {
    type: String,
    default: "",
  },
  orderBy: {
    type: String,
    default: "asc",
  },
  options: {
    type: Object,
    default: () => ({}),
  },
});

// Emits
const emit = defineEmits(["update:sort"]);

// Functions
const handleSort = () => {
  if (!props.isSortable) return;

  emit(
    "update:sort",
    props.field,
    props.sortBy === props.field && props.orderBy === "desc" ? "asc" : "desc"
  );
};
</script>
